import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["thumbnail", "videoContainer"];

  connect() {
    this.videoId = "3Qb2GS78QZM";
  }

  loadVideo() {
    // Hide thumbnail
    this.thumbnailTarget.classList.add("hidden");

    // Show video container
    this.videoContainerTarget.classList.remove("hidden");

    // Create and insert YouTube iframe
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.youtube-nocookie.com/embed/${this.videoId}?autoplay=1&rel=0&modestbranding=1&mode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent&controls=0&fs=0&disablekb=1`;
    iframe.className = "w-full h-full";
    iframe.frameBorder = "0";
    iframe.allowfullscreen = true;
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    iframe.allowFullscreen = true;

    // Clear container and add iframe
    this.videoContainerTarget.innerHTML = "";
    this.videoContainerTarget.appendChild(iframe);
  }
}
